"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var fileProviderStoreData = {
    fileProvidersViewState: [],
    addableFileProvidersViewState: [],
    isFileProvidersLoadingInProgress: false,
    areFileProvidersLoaded: false,
};
var fileProviderStore = satcheljs_1.createStore('fileProviderStore', fileProviderStoreData)();
exports.default = fileProviderStore;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/data/owa-fileprovider-store/lib/store/store.js
// module id = 1798
// module chunks = 2 3 40 106 107